import { render, staticRenderFns } from "./DepositAccounts.vue?vue&type=template&id=2db21fb8"
import script from "./DepositAccounts.vue?vue&type=script&lang=js"
export * from "./DepositAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports